import React from 'react';

import css from './SectionPostJob.module.css';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components';
import image from './images/image.png'

const SectionPostJob = props => {

    return (
        <div className={css.root}>

            <div className={css.horizontalWrapper}>

                <img className={css.image} src={image} />
                <div className={css.verticalWrapper}>

                    <p className={css.title}>
                        <FormattedMessage id="LandingClientsPage.SectionPostJob.title" />
                    </p>

                    <p className={css.info}>
                        <FormattedMessage id="LandingClientsPage.SectionPostJob.info" />
                    </p>

                    <Button>
                        <FormattedMessage id="LandingClientsPage.SectionPostJob.postJob" />
                    </Button>
                </div>

            </div>
        </div>
    );
};

export default SectionPostJob;
